import { PoleEmploiJobOrigine } from '@models/jobs/job-origine';
import { PoleEmploiPartenaire } from '@models/jobs/job-partenaire';

export interface PoleEmploiJob {
  id: string;
  intitule?: string;
  entreprise?: {
    nom?: string;
  };
  dateCreation?: Date;
  lieuTravail?: {
    libelle?: string;
  };
  typeContrat?: string;
  dureeTravailLibelle?: string;
  dureeTravailLibelleConverti?: string;
  origineOffre?: {
    urlOrigine: string;
    origine: PoleEmploiJobOrigine;
    partenaires: PoleEmploiPartenaire[];
  };
}

export interface PoleEmploiJobResponse {
  filtresPossibles: {
    agregation: {
      nbResultats: number;
      valeurPossible: string;
    }[];
    filtre: string;
  }[];
  resultats: PoleEmploiJob[];
}

export enum PoleEmploiOrigin {
  SUMMER_JOB,
  STUDENT_JOB,
  JOB,
}

export interface PoleEmploiJobList {
  hits: PoleEmploiJob[];
  nbHits: number;
}

export function toJobList(data: PoleEmploiJobResponse): PoleEmploiJobList {
  return {
    hits: data?.resultats || [],
    nbHits: data?.filtresPossibles[0]?.agregation?.reduce((acc, value) => acc + value.nbResultats, 0) || 0,
  };
}
